import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FormikProps, Formik, Form, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import InputDateTime from "../../../../components/Shared/InputDateTime";
import moment from "moment-timezone";

interface IFormProps {
    t?: any | undefined;
    moduleState: any;
    setQuery: any;
    dropdowns: any;
    visibility: any;
    toastify: any;
    onClose?: any;
}

type TInputForm = {
    toDate: null,
    fromDate: null,
};

const DEFAULT_FORM_STATE = {
    fromDate: moment().startOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
    toDate: moment().endOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
};

// @ts-ignore
function CvsApiLogFilter(props: IFormProps) {
    const { t, visibility, dropdowns } = props;
    const formRef: any = useRef();
    const [initFormState, setInitFormState] = useState<any>(DEFAULT_FORM_STATE);
    const [panelState, setPanelState] = useState<boolean>(false);
    // const [searchParams] = useSearchParams();

    const onSubmit = async (payloads: any) => {
        props.setQuery({
            ...props.moduleState,
            filters: payloads
        });
    };

    const onReset = () => {
        const base: any = formRef.current;
        if ( base ) {
            base.resetForm();
        }

        props.setQuery({
            ...props.moduleState,
            filters: {
                fromDate: moment().startOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
                toDate: moment().endOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
            }
        });
    };

    const onClose = () => {
        setPanelState(false);

        if ( props.onClose ) {
            props.onClose();
        }
    };

    useEffect(() => {
        if ( visibility ) {
            setPanelState(visibility);
            setInitFormState({ ...DEFAULT_FORM_STATE, ...props.moduleState.filters ?? [] });
        }
    }, [visibility]);


    return (
        <>
            <div>
                <Sidebar
                    header={
                        <div className="bg-body-tertiary card-header">
                            <h5 className={ "card-title mt-0" }>{ t('advance filters') }</h5>
                            <p>{ t("using filters you can archive better result.") }</p>
                        </div>
                    }
                    visible={ panelState } position="left" onHide={ onClose } blockScroll={ true }
                    style={ { width: '800px' } } closeOnEscape={ false }
                >
                    <div style={ {
                        height: '3px',
                        background: 'linear-gradient(90deg, var(--primary-color) 0%, rgba(33, 150, 243, 0) 50%)'
                    } }></div>
                    <Formik
                        innerRef={ formRef }
                        enableReinitialize={ true }
                        initialValues={ initFormState }
                        onSubmit={ onSubmit }
                    >
                        { (props: FormikProps<TInputForm>) => {
                            return (
                                <Form onSubmit={ props.handleSubmit }>
                                    <Row className={ "mt-4" }>
                                        <Col sm={ 12 } md={ 6 }>
                                            <Field component={ InputDateTime }
                                                   name="fromDate"
                                                   type={ "datetime" }
                                                   label={ t("from date") }
                                                   isClearable={ true }
                                                   autoFocus={ true }
                                                   enableTimeStartOfDay
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 6 }>
                                            <Field component={ InputDateTime }
                                                   name="toDate"
                                                   type={ "datetime" }
                                                   label={ t("to date") }
                                                   isClearable={ true }
                                                   enableTimeEndOfDay
                                            />
                                        </Col>
                                    </Row>
                                    <div className="filter filter-card-footer"
                                         style={ { width: '785px' } }>
                                        <Button type={ "submit" } disabled={ props.isSubmitting }
                                                tooltip={ t("to data save into database") }
                                                size={ "small" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-filter me-2" />
                                            { t("filter") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onReset }
                                                tooltip={ t("to make all fields empty") } className={ "ms-2" }
                                                size={ "small" } severity={ "warning" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-refresh me-2" />
                                            { t("reset") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onClose }
                                                tooltip={ t("operation cancel") } className={ "ms-2" }
                                                size={ "small" } severity={ "danger" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-arrow-left me-2" />
                                            { t("close") }
                                        </Button>
                                    </div>
                                </Form>
                            );
                        } }
                    </Formik>
                </Sidebar>
            </div>
        </>
    );
}

CvsApiLogFilter.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(CvsApiLogFilter);
